import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/solar-battery-installation")({
  head: () => ({
    meta: [
      { title: "Solar Battery Installation in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Home battery backup for Southern California homes. Keep power during outages and use your solar smarter under NEM 3.0." },
      { property: "og:title", content: "Solar Battery Installation – McKay Roofing & Solar" },
      { property: "og:description", content: "Home battery backup and smarter solar use across Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-battery-installation" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["solar-battery-installation"]} />,
});